// extracted by mini-css-extract-plugin
module.exports = {"container":"PrimaryVideoViewer_container__YzN9o","video":"PrimaryVideoViewer_video__UdsNe"};